import React, { useState, useMemo } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';

function AddFile() {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);

  const api = useMemo(() => {
    const instance = axios.create({
      baseURL: process.env.REACT_APP_API_URL,
      timeout: 30000,
      headers: {
        Accept: 'application/json',
      },
    });

    instance.interceptors.request.use((config) => {
      const token = localStorage.getItem('token');
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    });

    return instance;
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!file) {
      Swal.fire('Error', 'Please select a file.', 'error');
      return;
    }

    const formData = new FormData();
    formData.append('title', title);
    formData.append('description', description);
    formData.append('file', file);

    setLoading(true);

    try {
      const response = await api.post('/addfiles', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      Swal.fire('Success', response.data.message, 'success');

      // Reset form
      setTitle('');
      setDescription('');
      setFile(null);
      document.getElementById('fileInput').value = '';

    } catch (error) {
      Swal.fire(
        'Error',
        error.response?.data?.message || 'File upload failed.',
        'error'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="max-w-xl mx-auto p-6 bg-white rounded shadow">
      <h2 className="text-2xl font-bold mb-6">Upload Automation File</h2>

      <form onSubmit={handleSubmit} className="space-y-4">

        {/* Title */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            File Title
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            required
            className="mt-1 block w-full border rounded px-3 py-2 focus:ring focus:ring-blue-200"
          />
        </div>

        {/* Description */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Description
          </label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            rows="4"
            required
            className="mt-1 block w-full border rounded px-3 py-2 focus:ring focus:ring-blue-200"
          ></textarea>
        </div>

        {/* File Input */}
        <div>
          <label className="block text-sm font-medium text-gray-700">
            Select File
          </label>
          <input
          name='file'
            id="fileInput"
            type="file"
            onChange={(e) => setFile(e.target.files[0])}
            required
            className="mt-1 block w-full"
          />
        </div>

        {/* Submit Button */}
        <div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 text-white rounded ${
              loading ? 'bg-gray-400' : 'bg-blue-600 hover:bg-blue-700'
            }`}
          >
            {loading ? 'Uploading...' : 'Upload File'}
          </button>
        </div>

      </form>
    </div>
  );
}

export default AddFile;
